// base64 ↔ bytes, in one place.
//
// Everything the app moves across the Rust boundary that isn't text is base64: card PNGs, attachments,
// theme backgrounds, TTS audio, packed embedding vectors, gzipped card snapshots. Five modules had written
// the decode loop out (two of them in the same file) and three had written an encoder, two of which built
// the string one byte at a time.
//
// Re-exported from `api.ts`, which is where most callers already reach for them.

/** base64 → bytes. */
export function base64ToBytes(b64: string): Uint8Array {
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}

/**
 * bytes → base64, in 32k chunks.
 *
 * `String.fromCharCode(...bytes)` over a whole image is a spread of a million arguments and a stack
 * overflow; one `+=` per byte is safe but quadratic-ish on a megabyte theme background. Chunking is both.
 */
export function bytesToBase64(bytes: Uint8Array): string {
  let bin = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    bin += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return btoa(bin);
}

/** The payload of a `data:*;base64,…` URI, or the input when it is already bare base64. */
export const dataUriPayload = (uri: string): string => {
  const comma = uri.indexOf(",");
  return comma >= 0 ? uri.slice(comma + 1) : uri;
};
